"use strict";

exports.__esModule = true;
exports.getAllInstantaneousEventTypes = getAllInstantaneousEventTypes;
exports.getEventTypes = getEventTypes;
var _EventTimelineController = require("../../EventTimeline/EventTimelineController");
function getAllInstantaneousEventTypes() {
  return [_EventTimelineController.InstantaneousEventComments, _EventTimelineController.InstantaneousEventTickets, _EventTimelineController.InstantaneousEventAlerts];
}
function getEventTypes(_ref) {
  var showAlerts = _ref.showAlerts,
    showTickets = _ref.showTickets,
    showComments = _ref.showComments;
  var events = [];
  if (showTickets) {
    events.push(_EventTimelineController.InstantaneousEventTickets);
  }
  if (showAlerts) {
    events.push(_EventTimelineController.InstantaneousEventAlerts);
  }
  if (showComments) {
    events.push(_EventTimelineController.InstantaneousEventComments);
  }
  return events;
}